import React, { Suspense } from "react";
import { BrowserRouter as BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import SideNav from "./components/layout/SideNav";
import routes from './routes/index';
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./components/NotFound";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const queryClient = new QueryClient();
  return (
    <div id="main-wrapper">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Header />
          <SideNav />
          <ErrorBoundary>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                {routes.map((route, index) => {
                  return <Route key={index} path={route.path} element={route.element} />
                })}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
          {/* <Footer /> */}
        </BrowserRouter>
      </QueryClientProvider>
    </div>
  );
}

export default App;
